import React, {useEffect, useState} from 'react';
import {Button, Card, Stack} from 'react-bootstrap';
import Chart from "react-apexcharts";
import {Link} from 'react-router-dom';
import moment from "moment/moment";
import {DateUtils, DI, LepriconService, Loading, OrderPerformance, SelectedDate, UrlUtils} from "shared-lib";


const CHART_OPTIONS = {
    chart: {
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false,
        }
    },
    stroke: {
        curve: 'smooth',
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
        enabled: false,
    },
    yaxis: {
        labels: {
            show: false,
        }
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisTicks: {
            show: false,
        }
    },
    legend: {
        show: false
    }
} as any;

const lepriconService = DI.get(LepriconService);

export const AlgoRobotCardComponent: React.FunctionComponent<{ packageId: string }> = ({packageId}) => {
    const [inProgress, setInProgress] = useState(false);
    const [period] = useState({
        startDate: moment('2019-01-01', 'YYYY-MM-DD'),
        endDate: DateUtils.getEndOfToday()
    } as SelectedDate);
    const [chartData, setChartData] = useState(null);
    const packageDetail = lepriconService.getAlgoRobotPackageDetailById(packageId);
    const updateData = () => {
        if (!inProgress) {
            setInProgress(true);
            lepriconService.getOrderStatistics(period.startDate, period.endDate, packageDetail.alertName).then(resp => {
                updateChart(resp.performances);
            });
        }
    };

    const updateChart = (performances: OrderPerformance[]) => {
        if (performances.length > 0) {
            const inspector = performances[0];
            const dates = inspector.values.map(value => value.date);
            const series = performances.map(performance => ({
                name: performance.code,
                data: performance.values.map(value => value.percentage)
            }));
            const options = {...CHART_OPTIONS, xaxis: {...CHART_OPTIONS.xaxis, categories: dates}};
            setChartData({options, series});
            setInProgress(false);
        }
    }

    useEffect(() => {
        updateData()
    }, [packageId]);

    return (
        <div className="sl-loading-container d-flex">
            <Loading show={inProgress}/>
            <Card style={{flexGrow: 1}}>
                <div style={{minHeight: '250px'}}>
                    {chartData && <Chart options={chartData.options} series={chartData.series} type="line"/>}
                </div>
                <Card.Body>
                    <Card.Title>{packageDetail.name}</Card.Title>
                    <Stack direction="horizontal" gap={2}>
                        <Link className="btn btn-primary"
                              to={UrlUtils.generateAlgoRobotPackageDetailPageUrl(packageId)}>Performans Özeti</Link>
                        <Link className="btn btn-primary" to="#">Pakete Üye Ol</Link>
                    </Stack>
                </Card.Body>
            </Card>
        </div>

    );
}
